<template>
  <div>
    
    <p>Search this database to find internships for current CHS undergraduate students at partnered sites.</p>
    <ul>
      <li>Check our <a
          href="https://chs.asu.edu/current-students/experiential-learning/internships/FAQs"
          target="_blank"
          >Internship FAQ</a
        > page for answers to common student questions.
      </li>
      <li>Talk to your <a href="https://chs.asu.edu/current-students/undergraduate-advising" target="_blank">Academic Advisor</a> about any course enrollment questions.</li>
      <li>Once you enroll in an internship course, you will be added to our email list and receive important reminders from your <a href="https://chs.asu.edu/current-students/experiential-learning/internships/support" target="_blank">Internship Support Coordinator</a>.</li>
      <li>Make sure to submit all <a href="https://chs.asu.edu/current-students/experiential-learning/internships" target="_blank">required documentation</a> by posted deadlines in order to remain eligible for academic credit. </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>
